<style lang='scss'>
</style>

<script>
import Layout from '@layouts/main'

import {AxiosHelper} from '@src/utils/utils';
import Datatable from '@components/Datatable';

export default {
	components: { Layout, Datatable },
  data() {
    return {
			title: '살거 모니터링',

			searchKey : '',
			sites : [],
			targetIdx : 1,
			targets : [],
			recentList : [],

			tableOption1 : {
				paging : false,
				searching : false,
				// lengthChange: false,
				columns : [
					{data : 'idx', width : 35 },
					{data : 'name', width : 200 },
					{data : 'searchKey', width : 100 },
				],
				columnDefs: [
					{
						render : (data, type, row) => {
							return `
								<div class="button-list">
									<button type="button" data-type="view" class="btn btn-warning btn-xs waves-effect waves-light">보기</button>
									<button type="button" data-type="remove" class="btn btn-danger btn-xs waves-effect waves-light">삭제</button>
								</div>				
							`;
						},
						width : '100px',
						targets : 3
					},
				]
			},


			tableOption2 : {
				paging : false,
				searching : false,
				// lengthChange: false,
				columns : [
					{data : 'title' },
					{data : 'status' },
					{data : 'date' },
				],
				columnDefs: [
					{
						render : (data, type, row) => {
							return `
								<a href="${row.href}" target="_blank">${data}</a>
							`;
						},
						width : '100px',
						targets : 0
					},
				]
			},


		}
	},
	beforeCreate() {
		AxiosHelper.get(`/api/monitor/sites`).then(ret => {
			this.sites = ret.data
		});

	},
	created() {
		this.list();
	},
	mounted() {
	},
	methods : {
		list() {
			AxiosHelper.get(`/api/monitor`).then(ret => {
				this.targets = ret.data
			});
		},

		btnTest() {
			if(this.searchKey === '') {
				alert('검색어를 입력해야 합니다.');
				return;
			}

			const target = this.sites[this.targetIdx];
			let key = this.searchKey.split(",")[0];
			if(!target.charset) {
				AxiosHelper.get(`/api/encode/euc-kr/${key}`).then(ret => {
					key = ret.data;
					window.open(target.site + target.url.replace('[SEARCH]', key));
				});
			}
			else
				window.open(target.site + target.url.replace('[SEARCH]', key));
		},

		btnSave() {
			if(this.searchKey === '') {
				alert('검색어를 입력해야 합니다.');
				return;
			}

			AxiosHelper.post('/api/monitor', {
				seq : this.targetIdx,
				searchKey : this.searchKey,
			}).then(ret => {
				this.pushMessage('저장되었습니다.');
				this.list();
				AxiosHelper.get('/api/monitor/reload');	// 서버 스케쥴 새로고침
			})
		},

		clickHandler(index, data, event) {
			event.preventDefault();
			event.stopPropagation();

			if(event.target.dataset.type === 'view') {
				AxiosHelper.get(`/api/monitor/recent?idx=${data.idx}&seq=${data.seq}`).then(ret => {
					this.recentList = ret.data
				});
			}
			else if(event.target.dataset.type === 'remove') {
				if (!window.confirm("삭제할거야?")) {
					return;
				}

				AxiosHelper.delete(`/api/monitor/${data.seq}/${data.idx}`).then(ret => {
					this.pushMessage('삭제 완료');
					this.list();
					AxiosHelper.get('/api/monitor/reload');	// 서버 스케쥴 새로고침
				});
			}
		},


	}
}
</script>

<template>
  <Layout>
    <C.PageHeader :title="title" />

		<C.Row>
			<C.Col md="4">
				<C.Card>
					<C.CardHeader class="bg-secondary text-white">
						조건 설정
					</C.CardHeader>
					<C.CardBody>
						<div class="form-group row mb-3">
							<label class="col-3 col-form-label">검색어</label>
							<div class="col-9">
								<input v-model="searchKey" type="text" class="form-control" placeholder="모니터링할 검색어"/>
							</div>
						</div>
						<div class="form-group row mb-3">
							<label class="col-3 col-form-label">사이트</label>
							<div class="col-9">
								<select v-model="targetIdx" class="form-control">
									<option v-for="(item, idx) in sites" :key="item.seq" :value="idx">{{item.name}}</option>
								</select>
							</div>
						</div>
						<div class="button-list">
							<button type="button" class="btn btn-blue" @click="btnTest">테스트</button>
							<button type="button" class="btn btn-blue" @click="btnSave">등록</button>
						</div>
					</C.CardBody>
				</C.Card>
			</C.Col>

			<C.Col md="8">
				<C.Card>
					<C.CardHeader class="bg-secondary text-white">
						모니터링 목록
					</C.CardHeader>
					<C.CardBody>
						<Datatable
							:option="tableOption1"
							:data="targets"
							@clickHandler="clickHandler"
						>
							<template v-slot:thead>
								<tr>
									<th>id</th>
									<th>사이트</th>
									<th>검색어</th>
									<th>액션</th>
								</tr>
							</template>
						</Datatable>
					</C.CardBody>
				</C.Card>
			</C.Col>
		</C.Row>

		<C.Row>
			<C.Col md="12">
				<C.Card>
					<C.CardHeader class="bg-secondary text-white">
						감지된 목록
					</C.CardHeader>
					<C.CardBody>
						<Datatable
							:option="tableOption2"
							:data="recentList"
						>
							<template v-slot:thead>
								<tr>
									<th>게시물</th>
									<th>상태</th>
									<th>등록일자</th>
								</tr>
							</template>
						</Datatable>
					</C.CardBody>
				</C.Card>
			</C.Col>
		</C.Row>

  </Layout>
</template>